import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22font.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../public/fonts/lineto-brown-light.woff2%22,%22weight%22:%22200%22,%22style%22:%22normal%22},{%22path%22:%22../public/fonts/lineto-brown-regular.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22../public/fonts/lineto-brown-italic.woff2%22,%22weight%22:%22400%22,%22style%22:%22italic%22},{%22path%22:%22../public/fonts/lineto-brown-bold.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22}],%22variable%22:%22--font-brown-std%22}],%22variableName%22:%22brown%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'brown', 'brown Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
